import React from 'react'
import { AppRoutes } from './AppRoutes'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.min.css'
import './assets/styles/App.sass'

export const App: React.FC = () => {
  return (
    <div className='App'>
      <AppRoutes />
      <ToastContainer />
    </div>
  )
}
